<template>
    <article class="image-grid" :class="getModuleThemeClass()" v-if="item !== null">
        <template v-for="(image, index) in item.Images" :key="index">
            <image-component :image="image" module-name="image-grid" :sizes="getSizeParameters((index % 2 == 0 && index + 1 == item.Images.length))" />
        </template>
    </article>
</template>
<script>
import ImageComponent from '../components/image-component.vue';
import { useItem } from '../composables/item';
const { getThemeClass } = useItem();

export default {
    name: 'ImageGrid',
    components: {
        ImageComponent
    },
    props: {
        item: {
            type: Object,
            default: null
        },
        modalHasNavigation: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        getModuleThemeClass() {
            return getThemeClass(this.item);
        },
        getSizeParameters(isWide) {
            return [
                {
                    breakpoint: '1920',
                    width: isWide ? (this.modalHasNavigation ? '1232' : '1582') : (this.modalHasNavigation ? '581' : '756'),
                    height: this.modalHasNavigation ? '769' : '1000',
                    compression: 100
                },
                {
                    breakpoint: '992',
                    width: isWide ? (this.modalHasNavigation ? '1195' : '1545') : (this.modalHasNavigation ? '562' : '737'),
                    height: this.modalHasNavigation ? '727' : '953',
                    compression: 100
                },
                {
                    breakpoint: '480',
                    width: isWide ? (this.modalHasNavigation ? '595' : '855') : (this.modalHasNavigation ? '279' : '409'),
                    height: this.modalHasNavigation ? '525' : '358',
                    compression: 100
                },
                {
                    default: true,
                    width: isWide ? '419' : '198',
                    height: '253',
                    compression: 100
                }
            ];
        },
    }
};
</script>
